import { Component, OnInit } from '@angular/core';
import { GuideService } from '../../services/guide.service';
import { SubscriptionService } from '../../services/subscription.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-guide-list',
  templateUrl: './guide-list.component.html',
  styleUrls: ['./guide-list.component.less'],
})
export class GuideListComponent implements OnInit {
  guides: any[] = [];
  selectedGuide: any = null;
  showModal: boolean = false;

  constructor(private guideService: GuideService, private router: Router, private subscription: SubscriptionService) { }

  ngOnInit(): void {
    this.getGuides();
  }

  getGuides() {
    this.guideService.getGuides().subscribe((data: any) => {
      this.guides = data;
    });
  }

  openGuide(guide: any) {
    if (this.subscription.hasActiveSubscription()) {
      this.selectedGuide = guide;
      this.showModal = true;
      console.log("guide-list.component.ts [8c914c] openGuide: ", this.selectedGuide, this.showModal);
    }
    else {
      this.router.navigate(['/subscription'], {
        queryParams: { url: 'chat' },
      });
    }

  }

  closeModal() {
    this.selectedGuide = null;
    this.showModal = false;
  }
}
